import { render, staticRenderFns } from "./antetContent.vue?vue&type=template&id=2021940b&"
import script from "./antetContent.vue?vue&type=script&lang=js&"
export * from "./antetContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports